import messages from "./messages";

export type ConditionProduct = "activation" | "mail" | "optin";

export interface ConditionFilterProps {
  member: string;
}

export interface ResettableConditionFilterProps extends ConditionFilterProps {
  resetOnChange(): void;
}

export const labelByOption = {
  smaller: "less",
  "smaller-or-equals": "lessEqual",
  equals: "equals",
  greater: "greater",
  "greater-or-equals": "greaterEqual",
  empty: "empty",
  "not-empty": "notEmpty",
  contains: "contains",
  "contains-not": "containsNot",
  regex: "matchesRegex"
} as const;

export type ConditionOperator = keyof typeof labelByOption;
type ConditionMessageKey = (typeof labelByOption)[ConditionOperator];

export interface ConditionOption {
  value: ConditionOperator;
  label: (typeof messages)[ConditionMessageKey];
}

const isConditionOperator = (value: string): value is ConditionOperator =>
  Object.prototype.hasOwnProperty.call(labelByOption, value);

const getOption = (
  value: string,
  label: ConditionMessageKey | undefined
): ConditionOption | undefined => {
  if (!value || !label || !isConditionOperator(value)) return undefined;

  return {
    value,
    label: messages[label]
  };
};

export const getOptions = (
  options: readonly string[] | undefined,
  defaultOptions: readonly string[]
): ConditionOption[] =>
  [...defaultOptions, ...(options ?? [])].reduce<ConditionOption[]>((acc, value) => {
    const option = getOption(
      value,
      isConditionOperator(value) ? labelByOption[value] : undefined
    );
    if (option) acc.push(option);

    return acc;
  }, []);
